import React, { useEffect, useState } from "react";
import { Checkbox, Container, Form, Grid, GridColumn } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import XMLParser from "react-xml-parser";

import _ from "lodash";
import cx from "classnames";
import moment from "moment";

import {
  fetchUsersCount,
  fetchActiveUsersCount,
  fetchDeactivatedUsersCount,
  fetchNewUsers,
  fetchDAUCount,
  fetchWAUCount,
  fetchMAUCount,
} from "actions/users";

import { fetchAssetsCount } from "actions/assets";
import { fetchSharesCount } from "actions/shares";
import { fetchCollectionsCount } from "actions/collections";
import { fetchInvitationsCount } from "actions/invitations";
import { fetchSubscriptionPlan, updateSSOConfiguration,fetchAvailablePlans } from "actions/accounts";
import { fetchLicenceCount } from "actions/accounts";

import { DISABLED_STATUS } from "constants/appConstants";

// import AccountBasic from "./Basic";
import  BasicDetails  from "./BasicDetails";
import AccountSettings from "./Settings";
import AccountSubscription from "./Subscription";
import AccountOnboarding from "./AccountOnBoarding";
import PaperfliteDetails from "./PaperfliteDetails";
import CustomFonts from "./CustomFonts";
import SubscriptionPlan from "./SubscriptionPlan";
import DownloadInvoice from "./DownloadInvoice";

import styles from "./management.module.scss";
import SaveChanges from "components/ui/Buttons/SaveButton";
import Cancel from "components/ui/Buttons/CancelButton";
import ConfirmModal from "components/ui/ConfirmModal";
import classNames from "classnames";
import ColorCustomization from "./ColorPalette";
import { fetchingSSOConfiguration } from "actions/accounts";
import { useParams} from "react-router-dom";


const initMetrics = {
  users: {
    all: 0,
    active: 0,
    deactivated: 0,
    new: 0,
    dau: 0,
    wau: 0,
    mau: 0,
  },
  invitations: 0,
  assets: 0,
  shares: 0,
  collections: 0,
  licenceCount: 0,
  starterLicence: 0
};

const initSSOConfiguration = {
  entityId: "",
  loginUrl: "",
  logoutUrl: "",
  certificate: "",
  mandatory: false,
  autoProvision: false,
  domain: "",
};

let tagNames = [];

export default function AccountManagement({ account }) {
  const dispatch = useDispatch();

  const [disabled, setDisabled] = useState(false);
  const [subscriptionDisabled, setSubscriptionDisabled] = useState(false);
  const [
    extendTrialOrInvitationDisbaled,
    setExtendTrialOrInvitationDisabled,
  ] = useState(false);
  const permissionData = useSelector(
    (state) => _.get(state, "users.me.role") || {}
  );


  useEffect(() => {
    if (account) {
      if (account.subscription) {
        if (permissionData.key !== "Admin User") {
          setSubscriptionDisabled(false);
          setDisabled(false);
          setExtendTrialOrInvitationDisabled(false);

          if (DISABLED_STATUS.indexOf(account.subscription.type) !== -1) {
            if (!_.get(permissionData,"account.subscription")) {
              setSubscriptionDisabled(true);
            }
            setDisabled(true);
            setExtendTrialOrInvitationDisabled(true);
          }
        }
        if (!_.get(permissionData,"account.write")) {
          setDisabled(true);
        }
        if (!_.get(permissionData,"account.subscription")) {
          setSubscriptionDisabled(true);
        }
        if (!_.get(permissionData,"account.extendTrialOrInvitation")) {
          setExtendTrialOrInvitationDisabled(true);
        }
      }
    }
  }, [account, permissionData]);
  const getSubscriptionTypeStyle = () => {
    if (account && account.subscription) {
      if (account.subscription.type === "TRIAL") return styles.trial;
      else if (account.subscription.type === "PAID") return styles.paid;
      else if (account.subscription.type === "SUSPENDED")
        return styles.suspended;
      else if (account.subscription.type === "TERMINATED")
        return styles.terminated;
    }
  };

  return (
    <>
      <Container className={cx(styles.container)}>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              {account ? (
                <>
                  <span className={cx(styles.title)}> {account?.name} </span>
                  <span
                    className={cx(
                      styles.subscriptionType,
                      getSubscriptionTypeStyle()
                    )}
                  >
                    {account.subscription ? account.subscription.type : ""}
                  </span>
                </>
              ) : (
                ""
              )}
            </Grid.Column>
          </Grid.Row>

          <AccountMetrics account={account} />

          <Grid.Row columns={2}>
            <Grid.Column width={9}>
              <BasicDetails disabled={disabled} account={account} />
              <PaperfliteDetails account={account} />
              <CustomFonts account={account} />
            </Grid.Column>
            <Grid.Column width={7}>
              <Grid.Row>
                <SubscriptionPlan />
              </Grid.Row>
              <Grid.Row>
                <AccountSubscription
                  subscriptionDisabled={subscriptionDisabled}
                  extendTrialOrInvitationDisbaled={
                    extendTrialOrInvitationDisbaled
                  }
                  account={account}
                />
              </Grid.Row>
              <Grid.Row>
                <DownloadInvoice />
              </Grid.Row>
              <AccountOnboarding account={account} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <AccountSettings disabled={disabled} account={account} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              {permissionData &&
                permissionData.account &&
                permissionData.account.ssoConfiguration && (
                  <SSOConfiguration disabled={disabled} account={account} />
                )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </>
  );
}

function AccountMetrics({ account }) {
  const dispatch = useDispatch();

  const [metrics, setMetrics] = useState(initMetrics);

  const allUsers = useSelector((state) => _.get(state, "users.count.all"));

  const activeUsers = useSelector((state) =>
    _.get(state, "users.count.active")
  );
  const deactivatedUsers = useSelector((state) =>
    _.get(state, "users.count.deactivated")
  );
  const newUsers = useSelector((state) => _.get(state, "users.count.new"));
  const dau = useSelector((state) => _.get(state, "users.count.dau"));
  const wau = useSelector((state) => _.get(state, "users.count.wau"));
  const mau = useSelector((state) => _.get(state, "users.count.mau"));
  const allCollections = useSelector((state) =>
    _.get(state, "collections.count.all")
  );
  const allAssets = useSelector((state) => _.get(state, "assets.count.all"));
  const allShares = useSelector((state) => _.get(state, "shares.count.all"));
  const pendingInvitations = useSelector((state) =>
    _.get(state, "invitations.count.pending")
  );
  const noOfLicence = useSelector((state) => _.get(state,"accounts.licenceCount.count") || 0);

  const starterLicenceCount = useSelector((state) => _.get(state,"accounts.licenceCount.starterLicence") || 0);

  const params = useParams();

  useEffect(() => {
    setMetrics({ ...initMetrics });
  }, []);

  useEffect(() => {

    console.log("home account: ", account);

    if (account !== null && account !== undefined) {

      console.log("fetching: ");

      if (allUsers && !allUsers.fetching) {
        dispatch(fetchUsersCount({ account: account.id }));
      }

      if (activeUsers && !activeUsers.fetching) {
        dispatch(
          fetchActiveUsersCount({ account: account.id, type: "ACTIVE" })
        );
      }

      if (deactivatedUsers && !deactivatedUsers.fetching) {
        dispatch(
          fetchDeactivatedUsersCount({ account: account.id, type: "DISABLED" })
        );
      }

      if (_.get(metrics, 'licenceCount') === 0) {
        dispatch(fetchLicenceCount({ account: account.id }));
      }

      if (newUsers && !newUsers.fetching) {
        let from = moment()
          .startOf("month")
          .format("YYYY-MM-DD");
        let to = moment().format("YYYY-MM-DD");

        let filters = {
          account: account.id,
          dateField: "created_date",
          dateFrom: from,
          dateTo: to,
        };
        dispatch(fetchNewUsers({ filters }));
      }

      if (dau && !dau.fetching) {
        let from = moment().format("YYYY-MM-DD");
        dispatch(
          fetchDAUCount({ account: account.id, dateFrom: from, dateTo: from })
        );
      }

      if (wau && !wau.fetching) {
        let from = moment()
          .subtract(1, "week")
          .startOf("week")
          .format("YYYY-MM-DD");
        let to = moment()
          .subtract(1, "week")
          .endOf("week")
          .format("YYYY-MM-DD");
        dispatch(
          fetchWAUCount({ account: account.id, dateFrom: from, dateTo: to })
        );
      }

      if (mau && !mau.fetching) {
        let from = moment()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        let to = moment()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        dispatch(
          fetchMAUCount({ account: account.id, dateFrom: from, dateTo: to })
        );
      }

      if (allCollections && !allCollections.fetching) {
        dispatch(fetchCollectionsCount({ account: account.id }));
      }

      if (allAssets && !allAssets.fetching) {
        dispatch(fetchAssetsCount({ account: account.id }));
      }

      if (allShares && !allShares.fetching) {
        dispatch(fetchSharesCount({ account: account.id }));
      }

      if (pendingInvitations && !pendingInvitations.fetching) {
        dispatch(
          fetchInvitationsCount({ account: account.id, type: "PENDING" })
        );
      }
    }
  }, [account]);

  useEffect(() => {
    if(account && account.id) { 
    dispatch(
      fetchSubscriptionPlan({ account: account.id})
    );
    }
  }, [account]);


  useEffect(() => {
    dispatch(
      fetchAvailablePlans()
    );
    
  }, []);


  useEffect(() => {
    if (allUsers && !allUsers.fetching) {
      setMetrics({
        ...metrics,
        users: { ...metrics.users, all: allUsers.total },
      });
    }
  }, [allUsers]);

  useEffect(() => {
    if (activeUsers && !activeUsers.fetching) {
      setMetrics({
        ...metrics,
        users: { ...metrics.users, active: activeUsers.total },
      });
    }
  }, [activeUsers]);

  useEffect(() => {
    if (deactivatedUsers && !deactivatedUsers.fetching) {
      setMetrics({
        ...metrics,
        users: { ...metrics.users, deactivated: deactivatedUsers.total },
      });
    }
  }, [deactivatedUsers]);

  useEffect(() => {
    if (newUsers && !newUsers.fetching) {
      setMetrics({
        ...metrics,
        users: { ...metrics.users, new: newUsers.total },
      });
    }
  }, [newUsers]);

  useEffect(() => {
    if (dau && !dau.fetching) {
      setMetrics({
        ...metrics,
        users: { ...metrics.users, dau: dau.total },
      });
    }
  }, [dau]);

  useEffect(() => {
    if (wau && !wau.fetching) {
      setMetrics({
        ...metrics,
        users: { ...metrics.users, wau: wau.total },
      });
    }
  }, [wau]);

  useEffect(() => {
    if (mau && !mau.fetching) {
      setMetrics({
        ...metrics,
        users: { ...metrics.users, mau: mau.total },
      });
    }
  }, [mau]);

  useEffect(() => {
    if (allCollections && !allCollections.fetching) {
      setMetrics({ ...metrics, collections: allCollections.total });
    }
  }, [allCollections]);

  useEffect(() => {
    if (allAssets && !allAssets.fetching) {
      setMetrics({ ...metrics, assets: allAssets.total });
    }
  }, [allAssets]);

  useEffect(() => {
    if (noOfLicence && !noOfLicence.fetching) {
      setMetrics({ ...metrics, licenceCount: noOfLicence , starterLicence: starterLicenceCount});
     
    }
  }, [noOfLicence]);

  useEffect(() => {
    if (allShares && !allShares.fetching) {
      setMetrics({ ...metrics, shares: allShares.total });
    }
  }, [allShares]);

  useEffect(() => {
    if (pendingInvitations && !pendingInvitations.fetching) {
      setMetrics({ ...metrics, invitations: pendingInvitations.total });
    }
  }, [pendingInvitations]);

  return (
    <>
      <Grid.Row columns={8} className={styles.userMetricsRow}>
        <Metrics metric={metrics.users.all} label={<span>No of Users</span>} />
        <Metrics
          metric={metrics.users.active}
          label={
            <span>
              Active <br /> Users
            </span>
          }
        />
        <Metrics
          metric={metrics.users.deactivated}
          label={
            <span>
              Deactivated <br /> Users
            </span>
          }
        />
        <Metrics
          metric={metrics.users.dau}
          label={
            <span>
              Daily <br /> Active Users
            </span>
          }
        />
        <Metrics
          metric={metrics.users.wau}
          label={
            <span>
              Weekly <br /> Active Users
            </span>
          }
        />
        <Metrics
          metric={metrics.users.mau}
          label={
            <span>
              Monthly <br /> Active Users
            </span>
          }
        />
        <Metrics
          metric={metrics.users.new}
          label={
            <span>
              New Users <br /> (this month)
            </span>
          }
        />
        <Metrics
          metric={metrics.invitations}
          label={
            <span>
              Pending <br /> Invitations
            </span>
          }
        />
      </Grid.Row>

      {params.product !== "cleverstory" && (<Grid.Row columns={4} className={styles.collectionMetricsRow}>
        <Metrics
          metric={metrics.collections}
          label={<span> No. of Collections </span>}
        />
        <Metrics metric={metrics.assets} label={<span> No. of Assets </span>} />
        <Metrics metric={metrics.shares} label={<span> No. of Shares </span>} />
        <Metrics metric={metrics.licenceCount} label={<span>No. of Licence</span>} />
      </Grid.Row>)}
    </>
  );
}

function Metrics({ metric, label }) {
  return (
    <>
      <Grid.Column className={styles.metricsColumn}>
        <div className={cx(styles.metric)}>
          <div className={cx(styles.count)}>{metric}</div>
          <div className={cx(styles.label)}>{label}</div>
        </div>
      </Grid.Column>
    </>
  );
}

function SSOConfiguration({ account, disabled }) {
  const dispatch = useDispatch();
  const uploadXmlRef = React.createRef();
  const params = useParams();
  
  const initErrorFields = [
    {
      name: "loginUrl",
      error: false,
    },
    {
      name: "entityId",
      error: false,
    },
    {
      name: "certificate",
      error: false,
    },
  ];

  const updateAccountSSO = useSelector((state) =>
    _.get(state, "accounts.updateAccountSSO")
  );

  const [open, setOpen] = useState(false);
  const [ssoConfiguration, setSSOConfiguration] = useState(
    initSSOConfiguration
  );
  const [initialRendering, setInitialRendering] = useState(true);
  const [error, setError] = useState(null);
  const [errorFields, setErrorFields] = useState(initErrorFields);
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const fetchingSSO = useSelector(
    (state) => state.accounts.fetchingSSO
  );
  const populateSSO = useSelector((state) => state.accounts.SSO);
  const [disableSave, setDisableSave] = useState(false);
  const [initialSSO, setinitialSSO] = useState(initSSOConfiguration)
  

  useEffect(() => {
    if (!initialRendering && !updateAccountSSO.updating) {
      if (updateAccountSSO.success) {
        setOpen(false);
        setSSOConfiguration(initSSOConfiguration);
        toast.success("Updated SSO Configuration");
      } else {
        toast.error(updateAccountSSO.error);
      }
    }
  }, [updateAccountSSO]);

  useEffect(() => {
    validateFields();
  }, [ssoConfiguration]);

  useEffect(() => {
    if (_.isEqual(initialSSO,ssoConfiguration)) {
      setDisableSave(true);
    }
    else {
      setDisableSave(false);
    }
  }, [ssoConfiguration])

  useEffect(() => {
    if (!fetchingSSO.fetching && account) {
      
      dispatch(fetchingSSOConfiguration({ id : account.id }))
    }

      let data = {
        
        loginUrl: populateSSO.loginUrl,
        logoutUrl: populateSSO.logoutUrl,
        certificate: populateSSO.certificate,
        entityId:populateSSO.entityId,
        mandatory: populateSSO.mandatory,
        autoProvision: populateSSO.autoProvision,
        domain:populateSSO.domain
      };
      
      setSSOConfiguration(data)
      setinitialSSO(data)
      

  }, [account]);

  useEffect(() => {
   
    let data = {
      loginUrl: populateSSO.loginUrl,
      logoutUrl: populateSSO.logoutUrl,
      certificate: populateSSO.certificate,
      entityId:populateSSO.entityId,
      mandatory: populateSSO.mandatory,
      autoProvision: populateSSO.autoProvision,
      domain:populateSSO.domain
    };
    
    setSSOConfiguration(data)
    setinitialSSO(data)
    
  }, [populateSSO]);
  const handleUploadFile = (event) => {
    tagNames = [];
    var file = event.target.files[0];
    console.log(file);
    var fileType = file && event.target.files[0].type;

    if (fileType !== "text/xml") {
      return toast.error(
        "File type not supported. Please upload a valid xml file."
      );
    }

    var reader = new FileReader();
    reader.onload = function(event) {
      var xmlString = event.target.result;
      var xmlData = new XMLParser().parseFromString(xmlString);

      var entityTag = xmlData["name"];
      var childrenTag = xmlData["children"];

      getChildrenTags(childrenTag);

      console.log("tagNames", tagNames);

      let certificateTag = tagNames.filter((item) => {
        if (item.includes("Certificate")) {
          return item;
        }
      });
      let singleSignOnService = tagNames.filter((item) => {
        if (item.includes("SingleSignOnService")) {
          return item;
        }
      });

      var entityDescriptor = xmlData.getElementsByTagName(entityTag);
      var entityID = entityDescriptor[0].attributes.entityID;

      if (entityID === undefined) {
        setSSOConfiguration({
          ...ssoConfiguration,
          entityId: "",
          loginUrl: "",
          certificate: "",
        });
        toast.error("This xml file is not supported");
      } else {
        try {
          var certificateData = xmlData.getElementsByTagName(certificateTag[0]);
          var certificate = certificateData[0].value;
        } catch (e) {
          setSSOConfiguration({
            ...ssoConfiguration,
            certificate: "",
          });
          toast.error("Unable to extract certificate details");
        }

        try {
          var ssoData = xmlData.getElementsByTagName(singleSignOnService[0]);
          var loginUrl = ssoData[0].attributes.Location;
        } catch (e) {
          setSSOConfiguration({
            ...ssoConfiguration,
            loginUrl: "",
          });
          toast.error("Unable to extract Login URL details");
        }
      }

      setSSOConfiguration({
        ...ssoConfiguration,
        loginUrl: loginUrl,
        entityId: entityID,
        certificate: certificate,
      });
    };

    reader.readAsText(file);
  };

  const getChildrenTags = (tags) => {
    tags.forEach((item, index) => {
      tagNames.push(item.name);
      if (item.children) {
        getChildrenTags(item.children);
      }
    });
  };

  const onSaveChanges = (e) => {
    e.preventDefault();

    validateFields();
    setFormSubmitted(true);
    if (isFormValid()) {
      setOpen(true);
    } else {
      setError("Please enter values for required fields.");
    }
  };

  const onCancel = () => {
    setSSOConfiguration(initSSOConfiguration);
    uploadXmlRef.current.value = "";
    setSSOConfiguration(initialSSO)
  };

  const onModalConfirm = () => {
    dispatch(
      updateSSOConfiguration({
        id: account.id,
        ssoConfiguration: ssoConfiguration,
      })
    );
    uploadXmlRef.current.value = "";
  };

  const onModalCancel = () => {
    setOpen(false);
  };

  const isFieldError = (fieldName) => {
    let error = false;
    if (isFormSubmitted) {
      errorFields.forEach((field, idx) => {
        if (field.name === fieldName && field.error) {
          error = true;
        }
      });
    }

    return error;
  };

  const isFormValid = () => {
    let errors = errorFields.filter((item) => item.error);
    if (errors.length > 0) return false;

    return true;
  };

  const validateFields = () => {
    let fields = [];
    for (var i = 0; i < errorFields.length; i++) {
      let value = ssoConfiguration[errorFields[i].name];
      errorFields[i].error =
        value === null || value === undefined || value === "" ? true : false;
      fields.push(errorFields[i]);
    }
    console.log("errors: ", fields);

    setErrorFields(fields);
  };

  setTimeout(() => {
    setInitialRendering(false);
  }, [3000]);
  
  if (params.product === "cleverstory") {
    return null;
  }
  return (
    <>
      <Container className={cx(styles.ssoContainer)}>
        <div className={cx(styles.title)}>SSO Configuration</div>

        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column width={7}>
              <Form>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Form.Input
                        className={styles.ssoFormInput}
                        fluid
                        id="loginUrl"
                        label="Login URL"
                        placeholder="Login URL"
                        value={ssoConfiguration.loginUrl}
                        onChange={(e) =>
                          setSSOConfiguration({
                            ...ssoConfiguration,
                            loginUrl: e.target.value,
                          })
                        }
                        error={isFieldError("loginUrl")}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Form.Input
                        className={styles.ssoFormInput}
                        fluid
                        id="logoutUrl"
                        label="Logout URL"
                        placeholder="Logout URL"
                        value={ssoConfiguration.logoutUrl}
                        onChange={(e) =>
                          setSSOConfiguration({
                            ...ssoConfiguration,
                            logoutUrl: e.target.value,
                          })
                        }
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Form.Input
                        className={styles.ssoFormInput}
                        fluid
                        id="entityId"
                        label="Entity ID"
                        placeholder="Entity ID"
                        value={ssoConfiguration.entityId}
                        onChange={(e) =>
                          setSSOConfiguration({
                            ...ssoConfiguration,
                            entityId: e.target.value,
                          })
                        }
                        error={isFieldError("entityId")}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Form.Input
                        className={styles.ssoFormInput}
                        fluid
                        id="certificate"
                        label="Certificate"
                        placeholder="Certificate"
                        value={ssoConfiguration.certificate}
                        onChange={(e) =>
                          setSSOConfiguration({
                            ...ssoConfiguration,
                            certificate: e.target.value,
                          })
                        }
                        error={isFieldError("certificate")}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={11}>
                      <div>Mandatory</div>
                    </Grid.Column>
                    <Grid.Column width={5} className={styles.ssoToggle}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={ssoConfiguration.mandatory}
                        onChange={(e, { checked }) => {
                          setSSOConfiguration({
                            ...ssoConfiguration,
                            mandatory: checked,
                          });
                        }}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={11}>
                      <div>Auto Provision</div>
                    </Grid.Column>
                    <Grid.Column width={5} className={styles.ssoToggle}>
                      <Checkbox
                        className={styles.settingsToggle}
                        toggle
                        checked={ssoConfiguration.autoProvision}
                        onChange={(e, { checked }) => {
                          setSSOConfiguration({
                            ...ssoConfiguration,
                            autoProvision: checked,
                            domain: "",
                          });
                        }}
                        disabled={disabled}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  {ssoConfiguration.autoProvision && (
                    <>
                      <Grid.Row>
                        <Grid.Column>
                          <Form.Input
                            className={styles.ssoFormInput}
                            fluid
                            id="domain"
                            label="Domain"
                            placeholder="Domain"
                            value={ssoConfiguration.domain}
                            onChange={(e) =>
                              setSSOConfiguration({
                                ...ssoConfiguration,
                                domain: e.target.value,
                              })
                            }
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </>
                  )}
                </Grid>
              </Form>
            </Grid.Column>
            <Grid.Column width={1} className={styles.verticalLineWrapper}>
              <div className={styles.line}></div>
              <div className={styles.wordWrapper}>
                <div className={styles.word}>or</div>
              </div>
            </Grid.Column>
            <Grid.Column width={8} className={styles.ssoUpload}>
              <div className={styles.uploadArea}>
                <div className={styles.uploadAreaWrapper}>
                  <i className={cx("upload icon", styles.fileIcon)}></i>
                  <span className="description">
                    Upload SSO Configuration file
                  </span>
                  <label className={styles.fileUpload}>Upload</label>
                  <input
                    className={styles.fileUploadInput}
                    ref={uploadXmlRef}
                    type="file"
                    accept=".xml"
                    onChange={handleUploadFile}
                  />
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2}>
            <Grid.Column>
              {!isFormValid() && (
                <div className={cx(styles.error)}> {error}</div>
              )}
            </Grid.Column>
            <Grid.Column textAlign="right">
              <SaveChanges onClick={onSaveChanges} disabled = {disableSave}/>
              <Cancel onClick={onCancel} />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <ConfirmModal
          open={open}
          setOpen={setOpen}
          onSave={onModalConfirm}
          onCancel={onModalCancel}
          content={"Are you sure want to override sso confirguration?"}
        />
        
      </Container>
      <div className={cx(styles.colorCustomize)}>
        <ColorCustomization/>
      </div>
    </>
  );
}
